import React from 'react'

const CurrentRepositoryContext = React.createContext({} as Repository)

export function CurrentRepositoryProvider({repository, children}: React.PropsWithChildren<{repository: Repository}>) {
  return <CurrentRepositoryContext value={repository}> {children} </CurrentRepositoryContext>
}

export function useCurrentRepository() {
  return React.use(CurrentRepositoryContext)
}

export interface Repository {
  id: number
  name: string
  ownerLogin: string
  defaultBranch: string
  createdAt: string

  // used for api calls with file uploads
  databaseId?: number
  nameWithOwner?: string

  /**
   * Whether the user can push to this repository. It doesn't depend on the current ref.
   */
  currentUserCanPush: boolean
  /**
   * Indicates whether the repository is a fork.
   */
  isFork: boolean
  /**
   * Indicates whether the repository is a mirror of an upstream Git URL.
   */
  isMirror?: boolean
  /**
   * Indicates whether the repository has files.
   */
  isEmpty: boolean
  ownerAvatar: string
  public: boolean
  private: boolean
  isOrgOwned: boolean

  /** Whether repository Discussions are currently available. */
  hasDiscussionsEnabled?: boolean

  /** HTTPS git clone URL, host-correct for dotcom/GHES/proxima; server-provided only on payloads that need it. */
  httpCloneUrl?: string
}

export type RepositoryNWO = Pick<Repository, 'ownerLogin' | 'name'>
